var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _path7, _circle, _circle2, _path8, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white",
    stroke: "#FFAB2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2085 22.4614L20.3187 18.4062L27.9221 22.4614",
    stroke: "black",
    strokeWidth: 0.50689
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7153 30.57V24.4873H27.4151V30.57H22.3462V24.4873H18.2911V30.57H12.7153Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9221 23.477H12.2085L20.3187 19.4219L27.9221 23.477Z",
    stroke: "black",
    strokeWidth: 0.50689
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1948 31.5996H29.4429",
    stroke: "black",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3179 17.3921L15.249 19.9266C15.249 19.9266 15.4359 16.4037 16.2628 14.3508C16.5936 13.5296 17.2766 12.3232 17.2766 12.3232H22.8524C22.8524 12.3232 23.5354 13.5296 23.8662 14.3508C24.693 16.4037 24.8799 19.9266 24.8799 19.9266L20.3179 17.3921Z",
    stroke: "black",
    strokeWidth: 0.50689
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7705 11.3076L23.3601 11.3076",
    stroke: "black",
    strokeWidth: 0.50689
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5278,
    y: 9.02441,
    width: 5.07579,
    height: 1.52756,
    stroke: "black",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1835 7.76676L20.2685 7.29695L21.2194 7.76676H19.1835Z",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2298,
    cy: 6.84944,
    r: 0.4178,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.2299,
    cy: 6.43058,
    r: 0.2089,
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3447 5.66172V5.10059H21.1864L20.9059 5.38115L21.1864 5.66172H20.3447Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20.2886,
    y1: 6.22461,
    x2: 20.2886,
    y2: 5.10233,
    stroke: "black",
    strokeWidth: 0.112227
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemple);
export default __webpack_public_path__ + "static/media/TEMPLE.3758c5d8503b0e716f34f48f2aa4d5bd.svg";
export { ForwardRef as ReactComponent };